module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ../entities/maps/xml.json
// module id = 191
// module chunks = 0